import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '@graphql/admin/fragments';

export const addScheduledSessionMutation = gql`
  mutation AddScheduledSession($input: CreateScheduledSessionInput!) {
    addScheduledSession(input: $input) {
      ...AdminScheduledSessionFields
    }
  }

  ${scheduledSessionFieldsFragment}
`;